import { createRouter, createWebHistory } from 'vue-router'
//import { createRouter, createWebHashHistory } from 'vue-router'
import projectAbout from '../views/litigation/ProjectAboutView.vue'//项目介绍
import plaintiff from '../views/litigation/PlaintiffView.vue'//被告
import defendant from '../views/litigation/DefendantView.vue'//原告
import litigationProcess from '../views/litigation/LitigationProcessView.vue'//服务流程
import riskSelfAssessment from '../views/risk/RiskSelfAssessmentView.vue'//自评
import policyAdministration from '../views/risk/PolicyAdministrationView.vue'//保单管理
import policyShopping from '../views/risk/PolicyShoppingView.vue'//保险商城
import binding from '../views/binding/BindingInfoView.vue'//机构入驻
import binding_step_hosp from '../views/binding/BindingStep1View.vue'//机构邀请0
import privacyAgreement from '../views/binding/privacyAgreementView.vue'//隐私协议
import userServiceAgreement from '../views/binding/userServiceAgreementView.vue'//用户协议
import userOrder  from '../views/my/UserOrderView.vue'//用户订单
import HomeView  from '../views/my/homeView.vue'//关于我们
//验证一下
const routes = [
  {
    path: '/',
    name: 'home',
    meta:{
      title: '关于我们'      
    },
    component: HomeView
  }, 
  {
    path: '/projectAbout',
    name: 'projectAbout',
    meta:{
      title: '项目介绍'       
    },
    component: projectAbout
  },
  {
    path: '/plaintiff',
    name: 'plaintiff',
    meta:{
      title: '监理服务'       
    },
    component: plaintiff
  },
  {
    path: '/defendant',
    name: 'defendant',
    meta:{
      title: '诉讼管理'       //我是被告
    },
    component: defendant
  },
  {
    path: '/litigationProcess',
    name: 'litigationProcess',
    meta:{
      title: '服务流程'       //服务流程
    },
    component: litigationProcess
  },
  {
    path: '/riskSelfAssessment', 
    name: 'riskSelfAssessment',
    meta:{
      title: '风险自评'       //风险自评
    },
    component: riskSelfAssessment
  },
  {
    path: '/policyAdministration', 
    name: 'policyAdministration',
    meta:{
      title: '保单管理'       //保单管理
    },
    component: policyAdministration
  },
  {
    path: '/policyShopping', 
    name: 'policyShopping',
    meta:{
      title: '保险商城'       //保险商城
    },
    component: policyShopping
  },
  {
    path: '/binding',
    name: 'binding',
    meta:{
      title: '机构入驻'       //机构入驻
    },
    component: binding
  },
  {
    path: '/bindingStepHosp',
    name: 'bindingStepHosp',
    meta:{
      title: '机构分步邀请'       //title配置
    },
    component: binding_step_hosp
  },
  {
    path: '/userServiceAgreement',
    name: 'userServiceAgreement',
    meta:{
      title: '用户服务协议'       //机构入驻
    },
    component: userServiceAgreement
  },
  {
    path: '/privacyAgreement',
    name: 'privacyAgreement',
    meta:{
      title: '隐私服务协议'       //机构入驻
    },
    component: privacyAgreement
  },
  {
    path: '/userOrder',
    name: 'userOrder',
    meta:{
      title: '服务订单' 
    },
    component: userOrder
  }
]

const router = createRouter({
  history: createWebHistory(),
  //history: createWebHashHistory(),
  routes
})

export default router
